import React, { useState } from 'react'
import { Tag, TagLabel, TagCloseButton, Spinner } from '@chakra-ui/react'

function PurchaseTag({tag, purchase, deleteTag}) {
    const [isLoading, setIsLoading] = useState(false)

    const onDeleteTag = async () => {
        setIsLoading(true)
        await deleteTag(tag, purchase)
        setIsLoading(false)
    }

    return (
        <Tag m="2px">
            {isLoading
            ?
            <Spinner size='xs' />
            :
            <>
                <TagLabel whiteSpace='nowrap'>{tag.title}</TagLabel>
                <TagCloseButton onClick={onDeleteTag} />
            </>
            }
        </Tag>
    )
}

export default PurchaseTag
